var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProspectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1667 5.08337V7.91671H22.9167V12.1667H20.0833V7.91671H15.8333V5.08337H20.0833V0.833374H22.9167V5.08337H27.1667ZM22.9167 24.9167H3.08333V5.08337H11.5833V2.25004H3.08333C1.525 2.25004 0.25 3.52504 0.25 5.08337V24.9167C0.25 26.475 1.525 27.75 3.08333 27.75H22.9167C24.475 27.75 25.75 26.475 25.75 24.9167V16.4167H22.9167V24.9167ZM17.25 16.4167V22.0834H20.0833V16.4167H17.25ZM11.5833 22.0834H14.4167V10.75H11.5833V22.0834ZM8.75 22.0834V13.5834H5.91667V22.0834H8.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProspectIcon);
export default __webpack_public_path__ + "static/media/ProspectIcon.4f7b349851d20f7f57e01b23120bef44.svg";
export { ForwardRef as ReactComponent };